import { graphql } from "@/lib/gql/__generated__/gql";

export const RECEIPT_SETTING_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation ReceiptSettingUpdate($input: ReceiptSettingInput!) {
		receiptSettingUpdate(input: $input) {
			userErrors
			receiptSetting {
				id
				hotelID
				addressee
			}
		}
	}
`);
